import React, { SVGProps } from 'react';

const Logo = (props: SVGProps<SVGSVGElement>) => (
    <h4 className="logo-name">Mapsko Casa Bella Owners Association</h4>
);

export default Logo;
